import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const RootGuard = ({ children }) => {
  const { user } = useAuth();

  if (!user.isRoot) {
    return <Redirect to="/app/dashboard" />;
  }

  return <>{children}</>;
};

RootGuard.propTypes = {
  children: PropTypes.node
};

export default RootGuard;
